import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import { formatMoneda } from "../util/varios";
import moment from "moment";

const CatalogoNotaEntrega = (props) => {
  let op = require("../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({
    idnotaentrega: "",
    numnotaentrega: "",
  });
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "FECHA", textAlign: "center" },
    { label: "NÙMERO", textAlign: "center" },
    { label: "CEDULA/RIF", textAlign: "center" },
    { label: "NOMBRE", textAlign: "center" },
    { label: "MONTO", textAlign: "center" },
    { label: "ESTATUS", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.numnotaentrega
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              moment(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.cedularif.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = "";
    if (props.tip === "FA") {
      let campos = "*, agente.nombre";
      let nomtab = "notaentrega inner join agente on agente.idagente=idcliente";
      let nomid = "tipo";
      let id = props.tipo;
      endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    } else if (props.tip === "ND") {
      let campos = "*, agente.nombre";
      let nomtab = "notaentrega inner join agente on agente.idagente=idcliente";
      let nomid = "tipo";
      let id = props.tipo;
      endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    } else if (props.tip === "NE" && props.val === 'ORDEN') {
      endpoint = `${op.conexion}/api/inventario/seleccionarnotaentregadetordenescat`;
    } else {
      endpoint = `${op.conexion}/api/consulta/seleccionarnotaentrega`;
    }
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setValues({
      idnotaentrega: "",
      numnotaentrega: "",
    });
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarProducto = () => {
    props.onHideAceptaCatalogo(values);
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();

    setValues({
      idnotaentrega: item.idnotaentrega,
      numnotaentrega: item.numnotaentrega,
    });
    btnAcepta.current.focus();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            Seleccionar Nota de {props.tipo === "ND" ? "Debito" : "Entrega"}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-6 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control text-uppercase"
                ref={txtBuscar}
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        values.idnotaentrega === item.idnotaentrega
                          ? "lightskyblue"
                          : "white",
                    }}
                    onClick={seleccionarFila(item)}
                  >
                    <TableCell className="py-2 text-center align-middle">
                      {moment(item.fecha).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell className="py-2 text-center align-middle">
                      {item.numnotaentrega}
                    </TableCell>
                    <TableCell className="py-2 text-center align-middle">
                      {item.cedularif}
                    </TableCell>
                    <TableCell className="py-2 text-start align-middle">
                      {item.nombre}
                    </TableCell>
                    <TableCell className="py-2 text-end align-middle">
                      {formatMoneda(
                        item.totalmonto
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </TableCell>
                    <TableCell className="py-2 text-center align-middle">
                      <select
                        style={{
                          fontWeight: "bold",
                          color:
                            item.status === 0
                              ? "#007bff"
                              : item.status === 1
                              ? "#28a745"
                              : item.status === 4
                              ? "#dc3545"
                              : "#000000",
                        }}
                        disabled
                        defaultValue={item.status}
                        className="form-select-sm text-uppercase px-1"
                        aria-label=".form-select-sm example"
                      >
                        <option value="0">PENDIENTE</option>
                        <option value="1">PROCESADO</option>
                        <option value="4">ANULADO</option>
                      </select>
                    </TableCell>                   
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          onClick={seleccionarProducto}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoNotaEntrega;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoNotaEntrega.js